module.exports = __webpack_public_path__ + "img/panel3.288a78ab.svg";